<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import TestimonialCard from "@/features/testimonials/components/TestimonialCard.vue";

interface Testimonial {
  quote: string;
  author: string;
  logo?: string | null;
  context?: string;
}

const { tm, rt } = useI18n();

// 1. pull the raw array (typed as any[])
const raw = tm("testimonials.items") as any[];

// 2. map + resolve into your domain type
const testimonials = computed<Testimonial[]>(() =>
  raw.map(item => ({
    quote: typeof item.quote === "string" ? item.quote : rt(item.quote),
    author: typeof item.author === "string" ? item.author : rt(item.author),
    logo: item.logo == null ? null : typeof item.logo === "string" ? item.logo : rt(item.logo),
    context: item.context ? (typeof item.context === "string" ? item.context : rt(item.context)) : undefined,
  }))
);

// still just a string
const title = computed<string>(() => rt(tm("testimonials.title")));
</script>

<template>
  <section id="testimonials" class="py-20 bg-base-200">
    <div class="container mx-auto px-4 text-center">
      <h2 class="text-4xl font-semibold text-primary mb-10">
        {{ title }}
      </h2>
      <div class="grid gap-8 sm:grid-cols-2 md:grid-cols-3">
        <TestimonialCard v-for="t in testimonials" :key="t.author" :testimonial="t" />
      </div>
    </div>
  </section>
</template>
